import { render, staticRenderFns } from "./Hotspots.vue?vue&type=template&id=1db8f2b1&scoped=true&"
import script from "./Hotspots.vue?vue&type=script&lang=js&"
export * from "./Hotspots.vue?vue&type=script&lang=js&"
import style0 from "./Hotspots.vue?vue&type=style&index=0&id=1db8f2b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db8f2b1",
  null
  
)

export default component.exports